import { c as _c } from "react/compiler-runtime";
import { CSSProperties, ReactNode } from 'react';
import cx from 'classnames';
import './styles.scss';
interface QuestionProps {
  title: ReactNode;
  hint?: ReactNode;
  children?: ReactNode;
  addOn?: ReactNode;
  style?: CSSProperties;
  className?: string;
  size?: 'large' | 'middle';
}
export function Question(t0) {
  const $ = _c(34);
  let addOn;
  let children;
  let className;
  let hint;
  let rest;
  let style;
  let t1;
  let title;
  if ($[0] !== t0) {
    ({
      title,
      hint,
      addOn,
      children,
      className,
      size: t1,
      style,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = addOn;
    $[2] = children;
    $[3] = className;
    $[4] = hint;
    $[5] = rest;
    $[6] = style;
    $[7] = t1;
    $[8] = title;
  } else {
    addOn = $[1];
    children = $[2];
    className = $[3];
    hint = $[4];
    rest = $[5];
    style = $[6];
    t1 = $[7];
    title = $[8];
  }
  const size = t1 === undefined ? "large" : t1;
  let t2;
  if ($[9] !== className) {
    t2 = cx("app-question", className);
    $[9] = className;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  const t3 = size === "large";
  let t4;
  if ($[11] !== addOn || $[12] !== hint || $[13] !== t3) {
    t4 = cx("app-question-title", {
      "u-font-16": t3,
      "u-margin-bottom--tiny": hint,
      "u-flex-space-between": addOn
    });
    $[11] = addOn;
    $[12] = hint;
    $[13] = t3;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  let t5;
  if ($[15] !== title) {
    t5 = <div>{title}</div>;
    $[15] = title;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  let t6;
  if ($[17] !== addOn) {
    t6 = addOn ? <div className="u-margin-left--medium">{addOn}</div> : null;
    $[17] = addOn;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  let t7;
  if ($[19] !== t4 || $[20] !== t5 || $[21] !== t6) {
    t7 = <div className={t4}>{t5}{t6}</div>;
    $[19] = t4;
    $[20] = t5;
    $[21] = t6;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  let t8;
  if ($[23] !== hint) {
    t8 = hint ? <div id="question-hint" className="app-question-hint">{hint}</div> : null;
    $[23] = hint;
    $[24] = t8;
  } else {
    t8 = $[24];
  }
  let t9;
  if ($[25] !== t7 || $[26] !== t8) {
    t9 = <div className="u-margin-bottom--small" tabIndex={0}>{t7}{t8}</div>;
    $[25] = t7;
    $[26] = t8;
    $[27] = t9;
  } else {
    t9 = $[27];
  }
  let t10;
  if ($[28] !== children || $[29] !== rest || $[30] !== style || $[31] !== t2 || $[32] !== t9) {
    t10 = <div className={t2} style={style} {...rest}>{t9}{children}</div>;
    $[28] = children;
    $[29] = rest;
    $[30] = style;
    $[31] = t2;
    $[32] = t9;
    $[33] = t10;
  } else {
    t10 = $[33];
  }
  return t10;
}
export default Question;